export default "__VITE_ASSET__DgYNHaXL__"